import protobuf from "protobufjs";
import { decodeProtocolBuffer } from "../decode";
import protoRoot from "../proto-root";

function decode(base64: string): CameraStationPreview["image"] {
  const buffer = new Uint8Array(protobuf.util.base64.length(base64));
  protobuf.util.base64.decode(base64, buffer, 0);

  return decodeProtocolBuffer({
    typePath: "comm.CameraStationPreview.Image",
    buffer,
    root: protoRoot
  }) as CameraStationPreview["image"];
}

const previewImage = { decode };

export default previewImage;
